// src/components/general/Personas/PersonasTabs.jsx
import { useState } from 'react';
import DireccionesTab from '../../Tabs/DireccionesTab';
import IdentificacionesTab from '../../Tabs/IdentificacionesTab';
import ObservacionesTab from '../../Tabs/ObservacionesTab';
import OcupacionesTab from '../../Tabs/OcupacionesTab';
import TelefonosTab from '../../Tabs/TelefonosTab';
import EmailsTab from '../../Tabs/EmailsTab';
import PersonaRedSocialTab from '../../Tabs/PersonaRedSocialTab';

const tabsList = [
  { key: 'direcciones', label: 'Direcciones' },
  { key: 'identificaciones', label: 'Identificaciones' },
  { key: 'observaciones', label: 'Observaciones' },
  { key: 'ocupaciones', label: 'Habilidades' },
  { key: 'telefonos', label: 'Telefonos' },
  { key: 'correos', label: 'Correos Electrónicos' },
  { key: 'redSocial', label: 'Red Social' },
];

export default function PersonasTabs({ personId, puedeCrear, puedeEditar, puedeEliminar }) {
  const [active, setActive] = useState('direcciones');
  const hasValidContext = Number(personId || 0) > 0;

  if (!hasValidContext) {
    return (
      <div className="person-tabs-disabled">
        <span>
          Selecciona o crea una persona y pulsa <b>Editar</b> para gestionar sus datos
          relacionados.
        </span>
      </div>
    );
  }

  return (
    <div className="person-tabs-wrap">
      <div className="person-tabs-bar">
        {tabsList.map((t) => (
          <button
            key={t.key}
            className={`person-tab ${active === t.key ? 'is-active' : ''}`}
            onClick={() => setActive(t.key)}
          >
            {t.label}
          </button>
        ))}
      </div>

      <div className="person-tab-panel">
        {active === 'direcciones' && (
          <DireccionesTab
            fkValue={personId}
            puedeCrear={puedeCrear}
            puedeEditar={puedeEditar}
            puedeEliminar={puedeEliminar}
          />
        )}
        {active === 'identificaciones' && (
          <IdentificacionesTab
            fkValue={personId}
            puedeCrear={puedeCrear}
            puedeEditar={puedeEditar}
            puedeEliminar={puedeEliminar}
          />
        )}
        {active === 'observaciones' && (
          <ObservacionesTab
            fkValue={personId}
            puedeCrear={puedeCrear}
            puedeEditar={puedeEditar}
            puedeEliminar={puedeEliminar}
          />
        )}
        {active === 'ocupaciones' && (
          <OcupacionesTab
            fkValue={personId}
            puedeCrear={puedeCrear}
            puedeEditar={puedeEditar}
            puedeEliminar={puedeEliminar}
          />
        )}
        {active === 'telefonos' && (
          <TelefonosTab
            fkValue={personId}
            puedeCrear={puedeCrear}
            puedeEditar={puedeEditar}
            puedeEliminar={puedeEliminar}
          />
        )}
        {active === 'correos' && (
          <EmailsTab
            fkValue={personId}
            puedeCrear={puedeCrear}
            puedeEditar={puedeEditar}
            puedeEliminar={puedeEliminar}
          />
        )}
        {active === 'redSocial' && (
          <PersonaRedSocialTab
            fkValue={personId}
            puedeCrear={puedeCrear}
            puedeEditar={puedeEditar}
            puedeEliminar={puedeEliminar}
          />
        )}
      </div>
    </div>
  );
}
